import axios from "axios";

const sendEmailUrl =
  "https://europe-west1-anixe-pl.cloudfunctions.net/sendEmail";

export const sendEmail = async (template: string, recipient: string) =>
  await axios.post(sendEmailUrl, { template, recipient });
